import Icon from '../Icon';
import { IconSpecificProps } from '../Icon.types';

const IconX = ({ className, titleAccess }: IconSpecificProps) => (
  <Icon className={className} titleAccess={titleAccess} viewBox="0 0 26 24" fill="none">
    <path
      d="M13 12L3 2M13 12L23 22M13 12L23 2M13 12L3 22"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default IconX;
